import React from 'react';
import './Deposit.css'; // Reuse styles or create a dedicated modal CSS

function HowToDepositModal({ onClose }) {
  return (
    <div className="modal-backdrop" onClick={onClose}> {/* Close on backdrop click */}
      <div className="modal-content" onClick={e => e.stopPropagation()}> {/* Prevent closing when clicking inside modal */}
        <div className="modal-header">
          <h2>How to Deposit</h2>
          {/* Optional: Add a close button in the header */}
          {/* <button className="modal-close-button-header" onClick={onClose}>&times;</button> */}
        </div>
        <div className="modal-body">
          <p>
            To deposit money, first enter the amount you want to add to your wallet. 
            Then, copy the UPI ID mentioned below and complete the payment using 
            Paytm or any other payment app. Once the transaction is successful, upload 
            the payment screenshot using the upload button directly to the admin. 
            Finally, click on 'Add Money' button, and the amount will be credited to 
            your wallet within a minute.
          </p>
        </div>
        <div className="modal-footer">
          <button className="modal-close-button" onClick={onClose}>
            Close
          </button>
        </div>
      </div>
    </div>
  );
}

export default HowToDepositModal; 